import FingerprintJS from "@fingerprintjs/fingerprintjs";

const CACHE_KEY    = "qk_device_id";
const CACHE_KEY_TS = "qk_device_id_ts";
const CACHE_TTL    = 1000 * 60 * 60 * 24 * 30; // 30 días

// BUG CORREGIDO 1: El singleton `_promise` a nivel de módulo hacía que si
// Usuario A resolvía el fingerprint primero, Usuario B (misma pestaña, distinta
// cuenta) recibía exactamente el mismo _promise ya resuelto — el deviceId de A.
// Solución: sin singleton. Cada llamada verifica caché o genera fresh.

function generateFallbackId() {
  // BUG CORREGIDO 2: el fallback anterior podía retornar null si localStorage
  // estaba bloqueado, y null se guardaba en la DB como deviceId de varios usuarios,
  // provocando colisiones masivas. Ahora se genera un ID en memoria como último recurso.
  try {
    let id = localStorage.getItem(CACHE_KEY);
    if (id && id.length >= 8) return id;

    id = typeof crypto !== "undefined" && crypto.randomUUID
      ? crypto.randomUUID()
      : `fb-${Math.random().toString(36).slice(2)}-${Date.now().toString(36)}`;

    try {
      localStorage.setItem(CACHE_KEY,    id);
      localStorage.setItem(CACHE_KEY_TS, String(Date.now()));
    } catch { /* localStorage bloqueado — el id vive solo en esta llamada */ }

    return id;
  } catch {
    // Último recurso: ID efímero para esta sesión (no se persiste)
    return `tmp-${Math.random().toString(36).slice(2)}-${Date.now().toString(36)}`;
  }
}

export async function getDeviceId() {
  // 1. Caché válido en localStorage → retornar sin llamar a FingerprintJS
  try {
    const cached = localStorage.getItem(CACHE_KEY);
    const ts     = localStorage.getItem(CACHE_KEY_TS);
    if (cached && cached.length >= 8 && ts && Date.now() - Number(ts) < CACHE_TTL) {
      return cached;
    }
  } catch { /* localStorage bloqueado, continuar */ }

  // 2. Generar con FingerprintJS (sin singleton global)
  try {
    const fp          = await FingerprintJS.load();
    const { visitorId } = await fp.get();

    if (visitorId && visitorId.length >= 8) {
      try {
        localStorage.setItem(CACHE_KEY,    visitorId);
        localStorage.setItem(CACHE_KEY_TS, String(Date.now()));
      } catch { /* ignorar */ }
      return visitorId;
    }
    // FingerprintJS retornó algo vacío o inválido
    return generateFallbackId();
  } catch {
    // FingerprintJS lanzó error (bloqueado por ad-blocker, modo privado, etc.)
    return generateFallbackId();
  }
}

// Limpiar el deviceId del caché (llamar al hacer logout para que el próximo
// usuario del mismo navegador genere su propio ID fresco)
export function clearDeviceId() {
  try {
    localStorage.removeItem(CACHE_KEY);
    localStorage.removeItem(CACHE_KEY_TS);
  } catch { /* ignorar */ }
}
